import { TablePagination, Theme, withStyles } from '@material-ui/core';
import { createStyles, WithStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import React from 'react';
import IconDisplay from '../../components/UI/IconDisplay/IconDisplay';
import { IFeed, IFilters, IPlaylist, sort } from '../../models/states';
import smilie from '../../static/icons/smilie.svg';
import { getSorting, stableSort } from '../../utilities/utilities';
import PlaylistPodTableHeader from './PlaylistPodTableHeader';
import PlaylistPodTableItem from './PlaylistPodTableItem';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    tableRoot: {
      marginTop: '1rem'
    }
  });

class PlaylistPodTable extends React.Component<
  IPlaylistPodTableProps,
  IPlaylistPodTableState
> {
  constructor(props: IPlaylistPodTableProps) {
    super(props);
    this.state = {
      orderBy: 'sr_no',
      order: 'asc',
      page: 0,
      rowsPerPage: 25,
      isOpenFilters: {
        feeds: false,
        status: false,
        customer: false
      }
    };
  }
  handleChangePage = (event: React.MouseEvent<HTMLElement>, page: number) => {
    this.setState({ page });
  };

  handleRequestSort = (
    event: React.MouseEvent<HTMLElement>,
    property: string
  ) => {
    const orderBy = property;
    let order: 'asc' | 'desc' = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ orderBy, order });
  };

  renderTablePagination = (
    assets: IPlaylist[],
    rowsPerPage: number,
    page: number
  ): React.ReactNode => {
    return (
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 150]}
        component="div"
        count={assets.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onChangePage={this.handleChangePage}
        onChangeRowsPerPage={e =>
          this.setState({ rowsPerPage: parseInt(e.target.value, 10) })
        }
      />
    );
  };
  handleToggleHeaderFilters = (key: string) => {
    const updatedIsOpenFilter = { ...this.state.isOpenFilters };
    updatedIsOpenFilter[key] = !this.state.isOpenFilters[key];
    this.setState({ isOpenFilters: updatedIsOpenFilter });
  };
  renderRow = (playlist, index) => {
    const { page, rowsPerPage } = this.state;
    const { feedMap } = this.props;
    return (
      <PlaylistPodTableItem
        item={playlist}
        index={index + page * rowsPerPage}
        key={index + page * rowsPerPage}
        click={() => {
          this.props.onSelectPlaylist(playlist.id);
          this.props.onOpenPlaylistSummary();
        }}
        onEscalate={e => this.props.onEscalate(e, playlist.id)}
        feedMap={feedMap}
      />
    );
  };

  public render() {
    // const tableRows = [];
    const { classes, playlists } = this.props;
    const { rowsPerPage, page, order, orderBy } = this.state;
    const rows = stableSort(playlists, getSorting(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    return playlists.length === 0 ? (
      <IconDisplay
        logo={smilie}
        message={'No issues observed in the playlists!'}
      />
    ) : (
      <div>
        <Table className={classes.tableRoot}>
          <TableHead>
            <PlaylistPodTableHeader
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
              onToggleFilters={this.props.onToggleFilters}
              isOpenFilters={this.state.isOpenFilters}
              onToggleHeaderFilters={this.handleToggleHeaderFilters}
              filters={this.props.filters}
            />
          </TableHead>
          <TableBody>
            {rows.map((playlist: IPlaylist, index: number) => {
              return this.renderRow(playlist, index);
            })}
          </TableBody>
        </Table>

        {this.renderTablePagination(playlists, rowsPerPage, page)}
      </div>
    );
  }
}
interface IPlaylistPodTableState {
  order: sort;
  orderBy: string;
  page: number;
  rowsPerPage: number;
  isOpenFilters: any;
}
interface IPlaylistPodTableOwnProps {
  onToggleFilters: any; // todo: give proper signature
  filters: IFilters;
  playlists: IPlaylist[];
  feedMap: { [key: string]: IFeed };
  onSelectPlaylist: (playlistId: string) => any;
  onDeselectPlaylist: () => any;
  onEscalate: (e: any, playlistID: string) => any;
  onOpenPlaylistSummary: () => any;
}
type IPlaylistPodTableProps = WithStyles<typeof styles> &
  IPlaylistPodTableOwnProps;

export default withStyles(styles)(PlaylistPodTable);
